import React from 'react';
import { ILMOffice, ILMPractice } from '../../../types';
import { formatFullAddress } from '../../utils/formatAddress';
import { getOfficeBrandLogo, getOfficeBrandName } from '../../utils/officeBranding';
import DIGenericHeader, { DiHeaderSkeleton } from './DIGenericHeader';

interface ILMGroup {
  name: string;
  logo: string;
}

interface IProps {
  office?: ILMOffice;
  group?: ILMGroup;
  practice?: ILMPractice;
}

export default function LmHeader({ office, group, practice }: IProps) {
  if (office) {
    return (
      <DIGenericHeader
        logo={getOfficeBrandLogo(office, practice).logo}
        display={getOfficeBrandName(office, practice)}
        address={formatFullAddress(office)}
        phone={office.phone}
      />
    );
  }
  if (group) {
    return <DIGenericHeader logo={group.logo} display={group.name} />;
  }
  if (practice) {
    return <DIGenericHeader logo={practice!.logo} display={practice!.display} />;
  }
  return <DiHeaderSkeleton />;
}
